import { PaymentPlanType } from 'QuoteApp/services/endpoints/GetPaymentDetails';
import { FlexiblePaymentFrequency } from 'QuoteApp/services/endpoints/GetPaymentDetails';
import { RateType } from 'QuoteApp/services/endpoints/GetRate';

export const FLEX_PAYMENT_STATES = ['GA', 'FL'] as const;

export const isFlexPaymentState = (
  rate?: RateType | null,
  fallbackState?: string | null
): boolean => {
  const hasFlexiblePlan = rate?.paymentDetails?.attributes?.paymentPlans?.some(
    (plan) => plan.paymentPlanEnum === 'flexible'
  );

  if (hasFlexiblePlan) {
    return true;
  }

  const normalizedFallbackState = fallbackState?.trim().toUpperCase();

  if (!normalizedFallbackState) {
    return false;
  }

  return FLEX_PAYMENT_STATES.some((state) => state === normalizedFallbackState);
};

export const isInstallmentPlan = (paymentPlan: PaymentPlanType) =>
  paymentPlan.paymentFrequencyIdentifier === 'monthly' ||
  paymentPlan.paymentFrequencyIdentifier === 'semi_monthly' ||
  paymentPlan.paymentFrequencyIdentifier === 'bi_weekly' ||
  paymentPlan.paymentFrequencyIdentifier === 'weekly';

export const isPayInFullPlan = (paymentPlan: PaymentPlanType) =>
  paymentPlan.paymentFrequencyIdentifier === 'full_pay' ||
  paymentPlan.paymentFrequencyIdentifier === 'in_full';

export const isPayInFullOnlyRate = (rate: RateType): boolean => {
  const paymentPlans = rate.paymentDetails.attributes.paymentPlans;

  if (!paymentPlans.length) {
    return false;
  }

  return paymentPlans.every(isPayInFullPlan);
};

export const findPaymentPlanByIdentifier = (
  paymentPlans: PaymentPlanType[],
  identifier: string
): PaymentPlanType | undefined => {
  return paymentPlans.find((plan) => plan.identifier === identifier);
};

export const getSelectedPaymentPlan = (rate: RateType): PaymentPlanType => {
  const paymentDetails = rate.paymentDetails;

  const defaultPlanIdentifier =
    paymentDetails.attributes.defaultPaymentPlan.identifier;
  const paymentPlans = paymentDetails.attributes.paymentPlans;

  const selectedPlan = findPaymentPlanByIdentifier(
    paymentPlans,
    defaultPlanIdentifier
  );

  // Non-null assertion is safe: a default payment plan is always provided
  return selectedPlan!;
};

export const findPaymentPlanByFrequencyIdentifier = (
  paymentPlans: PaymentPlanType[],
  frequencyIdentifier: FlexiblePaymentFrequency
): PaymentPlanType | undefined => {
  return paymentPlans.find(
    (plan) => plan.paymentFrequencyIdentifier === frequencyIdentifier
  );
};

export const findPaymentScheduleEntryByType = (
  paymentSchedule: PaymentPlanType['paymentSchedule'],
  entryType: PaymentPlanType['paymentSchedule'][number]['type']
) => {
  return paymentSchedule.find((entry) => entry.type === entryType);
};

export const getPaymentPlanTotalCost = (paymentPlan: PaymentPlanType) => {
  const totalCost = paymentPlan.totalAmount;

  return totalCost;
};

export const getPaymentPlanTotalPremiumAmount = (
  paymentPlan: PaymentPlanType
) => {
  const totalPremiumAmount = paymentPlan.totalPremiumAmount;

  return totalPremiumAmount ? totalPremiumAmount : null;
};

export const getPaymentPlanDisplayName = (paymentPlan: PaymentPlanType) => {
  return paymentPlan.paymentFrequencyLabel;
};
